var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aboutcon"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.productname))]),_vm._v(" "),_c('div',{staticClass:"abcont1"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.detailBox)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7dbdb4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/case/detail.vue
// module id = null
// module chunks = 